exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".abnormal-modal-main[data-v-a08e2d64],.abnormal-modal-main .abnormal-modal-form[data-v-a08e2d64]{position:relative}.abnormal-modal-main .abnormal-modal-form .abnormal-tips-txt[data-v-a08e2d64]{padding:20px 50px;font-size:20px;font-weight:700}.abnormal-modal-main .abnormal-modal-form .abnormal-error-tips[data-v-a08e2d64]{color:#f20}.abnormal-modal-main .abnormal-modal-form .two-col-grid[data-v-a08e2d64]{display:grid;grid-template-columns:repeat(auto-fill,calc(50% - 10px));gap:10px}", ""]);

// exports
